/* eslint-disable i18next/no-literal-string */
import { AirplayVideo, Casting } from '@vgno/icons';

import { AirplayHelpLink, VGAndroidAppLink, VGIOSAppLink } from './links';

import * as styles from './Cards.module.scss';

export const castingContent = {
  title: 'Strøm fra VG mobilapp til TV-en',
  tabs: [
    {
      label: 'Chromecast',
      content: (
        <>
          <div>
            Du kan bruke <Casting className={styles.icon} />
            (Chromecast) via VG-appen, eller fra Chrome-nettleser på
            Android-telefoner, PC eller Mac for å se innhold på TV-en.
          </div>
          <div>
            Se etter “casting symbol” når du starter videoen du vil strømme.
          </div>
          <div>
            OBS! Safari-nettleser og iPhone/iPad nettleser støtter IKKE
            Chromecast. Brukere med generasjon 1 av Chromecast kan oppleve
            redusert kvalitet av castingen, dette skyldes at Google ikke støtter
            oppdatering av dette produktet lenger.
          </div>
          <div className={styles.appIcons}>
            <VGIOSAppLink />
            <VGAndroidAppLink />
          </div>
        </>
      ),
    },
    {
      label: 'Airplay',
      content: (
        <>
          <div>
            På iOS mobilenheter kan du bruke{' '}
            <AirplayVideo className={styles.icon} />
            (Airplay) fra VG-appen. Se etter Airplay når du starter videoen du
            vil strømme. Fra nettleser kan Airplay være svært ustabilt, derfor
            anbefaler vi at du laster ned VG-appen. Fra Mac gjør vi oppmerksom
            på at Chrome nettleser ikke støtter Airplay. Nyere versjoner av
            Safari kan særlig være ustabile for Airplay til Smart TV-er.
          </div>
          <div className={styles.airplayHelpLink}>
            <AirplayHelpLink />
          </div>
          <div className={styles.appIcons}>
            <VGIOSAppLink />
          </div>
        </>
      ),
    },
  ],
};
